import React, { FC, HTMLAttributes, useCallback } from 'react';
import classNames from 'classnames';
import { Badge, IconButtonWrapper } from 'components/ui';
import { useDispatchRequest } from '@redux-requests/react';
import { getApp, unlistPrivateApp } from 'modules/userApps/store/actions';
import { TooltipConfirm } from 'components';
import styles from './BranchInfo.module.scss';
import { t } from 'utils';

export interface IBranchInfo extends HTMLAttributes<HTMLDivElement> {
  title: string;
  appId: string;
  companyId: string;
  status: string;
  enterprise?: any;
  isEnterprise: boolean;
  className?: string;
  onUnlink?: any;
}

const BranchInfo: FC<IBranchInfo> = (props) => {
  const {
    appId,
    title,
    companyId,
    status,
    enterprise,
    isEnterprise,
    className,
    onUnlink = () => {},
    ...otherProps
  } = props;
  const dispatch = useDispatchRequest();
  const isPending = status === 'pending';

  const handleClick = useCallback(async () => {
    const branchId = isEnterprise ? null : companyId;
    const enterpriseId = isEnterprise ? companyId : null;
    const { data } = await dispatch(unlistPrivateApp(appId, branchId, enterpriseId));
    if (data) {
      await dispatch(getApp(appId));
      onUnlink();
    } else {
      return t('errors.somethingWentWrong');
    }
  }, [companyId, dispatch, appId, onUnlink, isEnterprise]);

  const rootClassName = classNames(styles.root, className, {
    [styles.pending]: isPending,
  });

  const warningIconClassName = classNames(styles.warningIcon, 'fa fa-exclamation-triangle');

  return (
    <div className={rootClassName} {...otherProps}>
      <p className={styles.title}>{title}</p>
      <p className={styles.text}>{companyId}</p>
      {isPending && <span className={warningIconClassName} />}
      <Badge className={styles.badge} text={status} />
      <TooltipConfirm
        title='tooltip.unathorize.title'
        text='tooltip.unauthorize.text'
        confirmText='tooltip.unauthorize.action'
        onConfirm={handleClick}
      >
        <IconButtonWrapper className={styles.button} icon='unlink' />
      </TooltipConfirm>
    </div>
  );
};

export default BranchInfo;
